import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// import photos from "../../assets/Ellipse 722.png";
import Header from "../Header/Header";
// import Menu from "../Menu/Menu";
import { FaRegEdit } from "react-icons/fa";
import { GrFormNext } from "react-icons/gr";
import Footer from "../Footer/Footer";
import { useTranslation } from "react-i18next";
import NoCopyWrapper from "../../utils/NoCopyWrapper";
import NoZoomWrapper from "../../utils/NoZoomWrapper";
const Edit = () => {
  const navigate = useNavigate(); // ✅ Add this here
  const { t } = useTranslation();

  const [form, setForm] = useState({
    fullName: "",
    email: "",
    phoneNumber: "",
    address: "",
    city: "",
    state: "",
    country: "",
    zipCode: "",
    avatar: "",
  });

  // ... rest of your code

  // Fetch data from API (simulate it here)
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          "https://rentel-network.up.railway.app/products/get-user-products",
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`, // 👈 Add this
            },
          }
        );

        const result = await response.json();

        const user = result[0]?.user;

        if (user) {
          const avatarUrl = user.avatar
            ? user.avatar.startsWith("http")
              ? user.avatar
              : `https://your-backend-url.com${user.avatar}`
            : "";

          setForm({
            fullName: user.fullName || "",
            email: user.email || "",
            phoneNumber: user.phoneNumber || "",
            address: user.address || "",
            city: user.city || "",
            state: user.state || "",
            country: user.country || "",
            zipCode: user.zipCode || "",
            avatar: avatarUrl,
          });
        }
      } catch (error) {
        console.error("Failed to fetch user data:", error);
      }
    };

    fetchData();
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const fetchUserProducts = async () => {
    try {
      const res = await fetch(
        "https://rentel-network.up.railway.app/products/get-user-products",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            // authentication header જો જરૂરી હોય તો
          },
        }
      );

      const data = await res.json();
      // console.log("User Products:", data);
    } catch (err) {
      console.error("Error fetching products:", err);
    }
  };

  const handleDiscard = () => {
    const userData = JSON.parse(localStorage.getItem("user")) || {};

    setForm({
      fullName: "",
      email: userData.email || "",
      phoneNumber: userData.phoneNumber || "",
      address: "",
      city: "",
      state: "",
      country: "",
      zipCode: "",
      avatar: "",
    });
  };

  const [editMode, setEditMode] = useState(false);
  const toggleEditMode = () => {
    setEditMode((prev) => !prev);
  };

  const handleAvatarChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setForm({ ...form, avatar: imageUrl });
      setAvatarFile(file); // we'll use this to upload
    }
  };
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const fallbackAvatar =
    storedUser?.avatar || "https://your-default-avatar-url.com/default.png";

  const [avatarFile, setAvatarFile] = useState(null);
  const LoginSuccessOrHeader = () => {
    const [avatar, setAvatar] = useState(avatar);
    useEffect(() => {
      const storedUser = localStorage.getItem("user");
      if (storedUser) {
        const parsedUser = JSON.parse(storedUser);
        if (parsedUser.avatar) {
          setAvatar(parsedUser.avatar);
        }
      }
    }, []);
  };

  // ✅ Fix handleUpdate
  const handleUpdate = async () => {
    try {
      const formData = new FormData();
      // console.log("Form data before appending:", form);

      formData.append("fullName", form.fullName);
      formData.append("address", form.address);
      formData.append("city", form.city);
      formData.append("state", form.state);
      formData.append("country", form.country);
      formData.append("zipCode", form.zipCode);

      if (avatarFile) {
        formData.append("avatar", avatarFile);
      }

      const res = await fetch("https://network.rentel.in/users/edit-user", {
        method: "PUT",
        body: formData,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      const result = await res.json();
      // console.log("Update response:", result);

      const updatedAvatar = result?.user?.avatar || form.avatar;

      const currentUser = JSON.parse(localStorage.getItem("user")) || {};

      const updatedUser = {
        ...currentUser,
        fullName: form.fullName,
        address: form.address,
        city: form.city,
        state: form.state,
        country: form.country,
        zipCode: form.zipCode,
        avatar: updatedAvatar,
      };

      localStorage.setItem("user", JSON.stringify(updatedUser));

      setForm((prev) => ({ ...prev, avatar: updatedAvatar }));

      navigate("/");
    } catch (err) {
      console.error("Update error:", err);
      alert("Failed to update profile");
    }
  };

  //email and phoneNumber no update

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("user"));
    if (userData) {
      setForm((prev) => ({
        ...prev,
        email: userData.email || "",
        phoneNumber: userData.phoneNumber || "",
      }));
    }
  }, []);

  return (
    <>
      <NoZoomWrapper>
        <NoCopyWrapper>
          <Header />
          {/* <Manu /> */}
          <div className="container">
            <div className="edit-desktop-view">
              <div className="profile-edit-container">
                <div className="profile-header">
                  <span className="breadcrumb" onClick={() => navigate("/")}>
                    Profile <GrFormNext />{" "}
                  </span>
                  <span className="edit-title">Edit Profile</span>
                </div>

                <div className="profile-card">
                  <div className="profile-photo-section">
                    <div className="detail">
                      <div className="profile-img-wrapper">
                        <img
                          src={form.avatar || fallbackAvatar}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src =
                              "https://your-default-avatar-url.com/default.png"; // Final fallback image
                          }}
                          alt="Profile"
                          className="profile-img-destop"
                        />

                        <label htmlFor="avatar-upload" className="upload-icon">
                          <FaRegEdit />
                        </label>
                        <input
                          type="file"
                          id="avatar-upload"
                          style={{ display: "none" }}
                          accept="image/*"
                          onChange={(e) => handleAvatarChange(e)}
                        />
                      </div>

                      <div className="Image-detail">
                        <p>{t("uploadProfilePhoto")}</p>
                        <p className="upload-info">{t("uploadInfo")}</p>
                      </div>
                    </div>
                  </div>

                  <div className="profile-form">
                    <div className="form-row">
                      <div className="first_anme">
                        <label className="label-name">{t("fullName")}</label>
                        <input
                          className="form-detail"
                          name="fullName"
                          placeholder={t("fullName")}
                          onChange={handleChange}
                          value={form.fullName || ""}
                        />
                      </div>
                      <div className="first_anme">
                        <label className="label-name">{t("email")}</label>
                        <input
                          className="form-detail"
                          name="email"
                          placeholder={t("email")}
                          value={form.email || ""}
                          readOnly
                        />
                      </div>
                    </div>

                    <div className="form-row">
                      <div className="first_anme">
                        <label className="label-name">{t("phoneNumber")}</label>
                        <input
                          className="form-detail"
                          name="phoneNumber"
                          placeholder={t("phoneNumber")}
                          value={form.phoneNumber || ""}
                          readOnly
                        />
                      </div>
                      <div className="first_anme">
                        <label className="label-name">{t("fullAddress")}</label>
                        <input
                          className="form-detail"
                          name="address"
                          placeholder={t("fullAddress")}
                          onChange={handleChange}
                          value={form.address || ""}
                        />
                      </div>
                    </div>

                    <div className="form-row">
                      <div className="second_anme">
                        <label className="label-name">{t("city")}</label>
                        <input
                          className="form-detail"
                          name="city"
                          placeholder={t("city")}
                          onChange={handleChange}
                          value={form.city}
                        />
                      </div>
                      <div className="second_anme">
                        <label className="label-name">{t("state")}</label>
                        <input
                          className="form-detail"
                          name="state"
                          placeholder={t("state")}
                          onChange={handleChange}
                          value={form.state}
                        />
                      </div>
                      <div className="second_anme">
                        <label className="label-name">{t("country")}</label>
                        <input
                          className="form-detail"
                          name="country"
                          placeholder={t("country")}
                          onChange={handleChange}
                          value={form.country}
                        />
                      </div>
                      <div className="second_anme">
                        <label className="label-name">{t("zipcode")}</label>
                        <input
                          type="text"
                          className="form-detail"
                          name="zipCode"
                          placeholder={t("zipcode")}
                          value={form.zipCode}
                          onChange={(e) => {
                            const onlyNums = e.target.value.replace(/\D/g, ""); // remove non-numbers
                            setForm({ ...form, zipCode: onlyNums });
                          }}
                        />
                      </div>
                    </div>

                    <div className="form-actions">
                      <button className="discard" onClick={handleDiscard}>
                        {t("discard")}
                      </button>
                      <button className="update" onClick={handleUpdate}>
                        {t("update")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* -=-=-=-=-=-=-=-=-=-=-==-=-mobile view=-=-=-=-=-=-==-=-=-=-=-=-=-=-=- */}
            <div className="edit-mobile-view">
              <div className="profile-edit-container-mobile">
                <div className="profile-header">
                  <span className="breadcrumb" onClick={() => navigate("/")}>
                    Profile <GrFormNext />{" "}
                  </span>
                  <span className="edit-title">Edit Profile</span>
                </div>

                <div className="profile-card-mobile">
                  {/* === Profile Row (Image + Full Name Input) === */}
                  <div className="profile-row-mobile">
                    {/* Left: Profile Image */}
                    <div className="profile-img-container-mobile">
                      <div className="profile-img-wrapper-mobile">
                        <img
                          src={form.avatar || fallbackAvatar}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src =
                              "https://your-default-avatar-url.com/default.png";
                          }}
                          alt="Profile"
                          className="profile-img-mobile"
                        />
                        <label
                          htmlFor="avatar-upload"
                          className="camera-icon-mobile"
                        >
                          <FaRegEdit />
                        </label>
                        <input
                          type="file"
                          id="avatar-upload"
                          style={{ display: "none" }}
                          accept="image/*"
                          onChange={handleAvatarChange}
                        />
                      </div>
                    </div>

                    {/* Right: Full Name Input */}
                    <div className="name-input-container-mobile">
                      <input
                        className="name-input-mobile"
                        name="fullName"
                        placeholder="Full Name"
                        onChange={handleChange}
                        value={form.fullName}
                      />
                    </div>
                  </div>

                  {/* === Email & Phone Number === */}
                  <div className="form-row-mobile">
                    <label className="label-name-mobile">Email</label>
                    <input
                      className="form-detail-mobile"
                      name="email"
                      placeholder="Email"
                      value={form.email || ""}
                      readOnly
                    />

                    <label className="label-name-mobile">Phone number</label>
                    <input
                      className="form-detail-mobile"
                      name="phoneNumber"
                      placeholder="Phone number"
                      value={form.phoneNumber || ""}
                      readOnly
                    />

                    <div className="first_anme">
                      <label className="label-name">{t("fullAddress")}</label>
                      <input
                        className="form-detail"
                        name="address"
                        placeholder={t("fullAddress")}
                        onChange={handleChange}
                        value={form.address || ""}
                      />

                      <div className="second_anme-mobile">
                        <label className="label-name">{t("city")}</label>
                        <input
                          className="form-detail"
                          name="city"
                          placeholder={t("city")}
                          onChange={handleChange}
                          value={form.city}
                        />
                      </div>
                      <div className="second_anme-mobile">
                        <label className="label-name">{t("state")}</label>
                        <input
                          className="form-detail"
                          name="state"
                          placeholder={t("state")}
                          onChange={handleChange}
                          value={form.state}
                        />
                      </div>
                      <div className="second_anme-mobile">
                        <label className="label-name">{t("country")}</label>
                        <input
                          className="form-detail"
                          name="country"
                          placeholder={t("country")}
                          onChange={handleChange}
                          value={form.country}
                        />
                      </div>
                      <div className="second_anme-mobile">
                        <label className="label-name">{t("zipcode")}</label>
                        <input
                          type="text"
                          className="form-detail"
                          name="zipCode"
                          placeholder={t("zipcode")}
                          value={form.zipCode}
                          onChange={(e) => {
                            const onlyNums = e.target.value.replace(/\D/g, ""); // remove non-numbers
                            setForm({ ...form, zipCode: onlyNums });
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  {/* === Update Button === */}
                  <div className="form-actions-mobile">
                    <button className="update-mobile" onClick={handleUpdate}>
                      {t("update")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </NoCopyWrapper>
      </NoZoomWrapper>
    </>
  );
};

export default Edit;
